import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export const ScrollToTop = () => {
  const { pathname, search, hash } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    // Normalize trailing slashes to prevent duplicate URLs in Search Console
    // ("Alternate page with proper canonical tag"). Keep root "/" as-is.
    if (pathname.length > 1 && pathname.endsWith("/")) {
      const stripped = pathname.replace(/\/+$/, "");
      navigate(stripped + search + hash, { replace: true });
      return;
    }
    window.scrollTo(0, 0);
  }, [pathname, search, hash, navigate]);

  return null;
};
